export default "__VITE_ASSET__CmFAUGC6__"